import { render } from "./m-loby.vue?vue&type=template&id=c22cbd52&scoped=true&ts=true"
import script from "./m-loby.vue?vue&type=script&lang=ts"
export * from "./m-loby.vue?vue&type=script&lang=ts"

import "./m-loby.vue?vue&type=style&index=0&id=c22cbd52&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22cbd52"]])

export default __exports__